module["exports"] = [
  "Rock",
  "Metal",
  "Pop",
  "Electronic",
  "Folk",
  "World",
  "Country",
  "Jazz",
  "Funk",
  "Soul",
  "Hip Hop",
  "Classical",
  "Latin",
  "Reggae",
  "Stage And Screen",
  "Blues",
  "Non Music",
  "Rap"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/music/genre.js
// module id = 2669
// module chunks = 1610